/**
 * Authentication mixin for main.js
 * This mixins will watch for changes in
 * authenticated status and act accordingly.
 */
import { mapActions, mapGetters } from "vuex"

export default {
  computed: {
    ...mapGetters({ isAuthenticated: "auth/isAuthenticated" })
  },
  created () {
    this.authInit()

    // check user every 30 minutes
    const interval = 1000 * 60 * 30
    setTimeout(() => {
      setInterval(this.authInit, interval)
    }, interval)

    /**
     * Incase of 401, logout the user
     * this is Axios interceptor on every request
     */
    let authInterceptor = window.axios.interceptors.response.use((response) => { return response }, (error) => {
      if (error.response.status === 401 && !this.user) {
        this.authLogout()
        return Promise.reject(error)
      }
      if (error.response.status === 401 && this.user) {
        /*
         * When response code is 401, try to refresh the token.
         * Eject the interceptor so it doesn't loop in case
         * token refresh causes the 401 response
         */
        window.axios.interceptors.response.eject(authInterceptor)
        const originalRequest = error.config
        this.authRefreshToken()
        if (!error.config.__isRetryRequest) {
          // Retry with original request
          return new Promise((resolve) => {
            error.config.__isRetryRequest = true
            resolve(window.axios(originalRequest))
          })
        }
        this.authLogout()
      }
      return Promise.reject(error)
    })
  },
  methods: {
    ...mapActions({
      authInit: "auth/init",
      authRefreshToken: "auth/getUser",
      authLogout: "auth/logout"

    })
  },
  watch: {
    isAuthenticated (state, oldState) {
      if (!state && !this.$route.path.startsWith("/login")) {
        this.$router.push("/login")
        return false
      }
      if (state && this.$route.path.startsWith("/login")) {
        this.$router.push("/documents-overview")
      }
      return false
    }
  }
}
